import React from 'react';
import { getCategoryColor } from '../../constants/categories';

const CategoryBadge = ({ category, slug }) => {
  const color = getCategoryColor(slug || category);
  
  const getCategoryName = (cat) => {
    const names = {
      'genel-haberler': 'Genel',
      'spor-haberleri': 'Spor',
      'teknoloji-haberleri': 'Teknoloji',
      'ekonomi-haberleri': 'Ekonomi'
    };
    return names[cat] || cat || 'Haber';
  };

  return (
    <span
      className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
      style={{
        backgroundColor: `${color}20`,
        color: color
      }}
    >
      {getCategoryName(category || slug)}
    </span>
  );
};

export default CategoryBadge;
